<template>
	<div class="home">
		<Header ref="header" :type='headType'></Header>
		<BanIn url="image004">
			<template v-slot:text>
				<h2 class="inTit f48 wow fadeInLeft">新闻资讯</h2>
				<div class="inDes f24 wow fadeInRight">
					<p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
				</div>
			</template>
		</BanIn>
        <div class="mainBg">
            <div class="newsBg">
                <div class="wrap">
                    <div class="newsHead wow fadeInUp">
                        <ul class="breadNav fr">
                            <li><router-link to="/">首页</router-link></li>
                            <li><router-link to="/news">新闻中心</router-link></li>
                            <li class="active">新闻详细</li>
                        </ul>
                        <div class="left">
                            <h1 class="title f24 color0">{{info.title}}</h1>
                            <p class="time color6">
                                <span>时间：{{ info.article_date }}</span>
                                <span>信息来源：<strong>{{info.company_text}}</strong></span>
                            </p>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="newsBody editor f18 color6 wow fadeInUp" v-html="info.content"></div>
					<h2 class="caseH2 f24 color0" v-if="info.file_list != null">相关附件</h2>
					<ul class="annexList f18 color3" v-if="info.file_list != null">
						<li v-for="(item, index) in info.file_list" :key="index"><span class="ellipsis">GRP78 Polyclonal.docx</span><router-link :to="item">在线预览</router-link></li>
					</ul>
                    <div class="newsPage flex f16 wow fadeInUp">
                        <div class="item">
                            <p class="color_m"><i class="el-icon-back"></i><span>上一篇</span></p>
                            <p class="color2 ellipsis" v-if="prev.id == ''">{{prev.title}}</p>
                            <p class="ellipsis" v-else><router-link :to="'newsDetail?id='+prev.id">{{prev.title}}</router-link></p>
                        </div>
                        <div class="item">
                            <p class="color_m"><span>下一篇</span><i class="el-icon-right"></i></p>
                            <p class="color2 ellipsis" v-if="next.id == ''">{{next.title}}</p>
                            <p class="ellipsis" v-else><router-link :to="'newsDetail?id='+next.id">{{next.title}}</router-link></p>
                        </div>
                    </div>
                    <a class="backList f16 color_f wow fadeInUp" href="/news">返回列表</a>
                </div>
            </div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import Header from '@/components/Header.vue'
import BanIn from '@/components/BanIn.vue'
import Footer from '@/components/Footer.vue'
import { WOW } from 'wowjs'
import home from '../api/home'
// import home from '@/api/home'
export default {
    name: 'newsDetail',
    components: {
        Header,
        BanIn,
        Footer
    },
    data() {
        return {
            headType:3,
            id:"",
			info:{},
			prev:{},
			next:{}
        }
    },
    watch: {
        '$route' () {
            this.getData(this.$route.query.id)
        }
    },
    computed: {
        
    },

    created() {
    },
    mounted () {
        this.$nextTick(()=>{
            new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()            

            // // 动态内容加载完成后调用 sync 方法，确保在每次动态加载内容后调用 this.$wow.sync() 方法，以便 WOW.js 能够重新扫描页面并为新的 wow 元素添加动画（没起作用）
            // this.$nextTick(() => {
            //   this.$wow.sync();
            // });
        });
        this.id = this.$route.query.id;
		this.getData(this.id);
    },
    methods: {
        getData(id){
            this.id = id;		
			home.newsInfo({id:this.id}).then((res)=>{
				if (res.code === 1) {
					this.info = res.data
					this.prev = this.info?.prev
					this.next = this.info?.next
				} else {
					this.$toast(res.msg)
				}
			});
        },
    },
    destroyed(){
        
    }
}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/case.scss';
	@import '@/assets/css/news.scss';
</style>